export default __webpack_public_path__ + "static/Enterprise-Mobility-cb795c164d0c158927a2376e7258e6ca.webp";